<template>
    <div class="page orders-page px-md-8"> <!-- white fill-height -->
        <transition name="fade-transition">
            <v-container v-if="orderData" class="py-3 py-lg-8 px-0" style="max-width: 1100px!important">
                <div class="d-flex flex-column flex-lg-row">
                    <div class="flex-grow-1 me-lg-12 overflow-hidden px-2 px-lg-1">
                        <div class="d-flex justify-space-between mb-6 mb-lg-10 pa-2 pa-lg-0">
                            <div class="me-4 me-lg-8">
                                <v-avatar color="white" height="60" width="60" style="border-radius: 8px" class="bordered">
                                    <v-icon size="28" color="primary">mdi-cart</v-icon>
                                </v-avatar>
                            </div>
                            <div class="flex-grow-1">
                                <div class="mb-1">
                                    <v-btn small text color="muted" class="px-1" @click="goBack" exact>
                                        <v-icon size="20" left class="me-1">mdi-chevron-right</v-icon>
                                        <span>العودة للخلف</span>
                                    </v-btn>
                                </div>
                                <h2 class="strong-text--text font-weight-medium default-font">طلب رقم #{{orderData.local_serial}}</h2>
                                <div class="mt-3">
                                    <v-chip label class="px-2 me-2 ltr-dir" style="height: 20px; background-color: rgba(0,0,0, .04)!important; font-size: 14px">
                                        <v-icon size="16" color="text" class="ms-2">mdi-calendar</v-icon>
                                        <span>{{dateTimeFormat(orderData.created_at, true)}}</span>
                                    </v-chip>
                                </div>
                                <div class="mt-3 d-flex align-center">
                                    <v-chip label small dark :color="orderStatusChip.color">
                                        <v-icon left size="16" class="me-2">{{orderStatusChip.icon}}</v-icon>
                                        {{orderStatusChip.text}}
                                    </v-chip>
                                    <div v-if="phoneOnly" class="ms-3">
                                        <v-menu v-if="actions && actions.length" bottom :offset-y="true" transition="slide-y-transition">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="white" small v-bind="attrs" v-on="on">
                                                    <v-icon left class="me-1">mdi-dots-vertical</v-icon>
                                                    <span>إجراءات</span>
                                                </v-btn>
                                            </template>
                                            <v-list dense min-width="250">
                                                <v-list-item v-for="action in actions" :key="action.name" @click="action.onclick" :disabled="action.disabled" v-show="!action.hide" v-ripple="{class: 'ripple--color'}">
                                                    <v-list-item-icon class="me-4">
                                                        <v-icon size="22" :color="action.color" :style="action.disabled ? 'opacity: 0.5' : ''">{{action.icon}}</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="medium-text mb-0" style="line-height: 1.6!important">{{action.title}}</v-list-item-title>
                                                        <v-list-item-subtitle class="details-text" style="line-height: 1.5!important" :style="action.disabled ? 'opacity: 0.5' : ''">{{action.subtitle}}</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </div>
                                <!-- <v-divider class="my-3"></v-divider> -->
                                <!-- <div class="mt-6 w-100">
                                    <v-btn as="a" target="_blank" color="white" v-ripple="phoneOnly">
                                        <v-icon size="21" left>mdi-printer</v-icon>
                                        <span>طباعة الطلب</span>
                                    </v-btn>
                                </div> -->
                            </div>
                        </div>

                        <v-card flat class="bordered mb-4 mb-lg-6 py-lg-1 px-lg-2">
                            <v-card-title class="medium-title">
                                <v-icon color="strong-text" size="22" class="me-2">mdi-cart-outline</v-icon>
                                <span>تفاصيل الطلب</span>
                            </v-card-title>
                            <!-- <v-card-subtitle class="details-text muted--text"></v-card-subtitle> -->
                            <v-card-text>
                                <v-simple-table class="cart-table pa-0 ma-0 transparent flex-grow-1 mb-6">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-right font-weight-medium">المنتج</th>
                                                <th class="text-right font-weight-medium">السعر</th>
                                                <th class="text-center font-weight-medium">الكمية</th>
                                                <th class="text-center font-weight-medium">الإجمالي</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item) in orderData.items" :key="item.id">
                                                <td class="d-flex align-center" style="height: 90px">
                                                    <div>
                                                        <router-link :to="{name: 'product', params: {id: item.product.id}}">
                                                            <v-avatar size="60" tile v-ripple="{class: 'white--text'}">
                                                                <v-img :src="item.product.main_image_url"></v-img>
                                                            </v-avatar>
                                                        </router-link>
                                                    </div>
                                                    <div class="ms-5">
                                                        <router-link :to="{name: 'product', params: {id: item.product.id}}" style="text-decoration: none;">
                                                            <div class="mb-1 strong-text--text" style="font-size: 16px; line-height: 1.4; white-space: nowrap;">{{item.product.name}}</div>
                                                        </router-link>
                                                        <div class="text--text" style="font-size: 14px">{{item.variant.name}}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span v-if="item.product_price !== item.purchasing_price" class="grey--text me-1 font-weight-medium" style="text-decoration: line-through;">{{moneyFormat(item.product_price)}}</span>
                                                    <div>{{moneyFormat(item.purchasing_price)}}</div>
                                                </td>
                                                <td>
                                                    <div class="d-flex justify-center">
                                                        <div class="d-flex align-center bordered rounded py-1 font-weight-bold">
                                                            <div class="px-3" style="border-left: 1px solid rgba(0,0,0, .07); border-right: 1px solid rgba(0,0,0, .07);">{{item.quantity}}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div>
                                                        <b class="medium-text">{{moneyFormat(item.total)}}</b>
                                                    </div>
                                                </td>
                                                <!-- <td class="text-left">
                                                    <v-btn icon outlined color="error" width="35" height="35" @click="removeFromCart(item.id)">
                                                        <v-icon size="18">mdi-close</v-icon>
                                                    </v-btn>
                                                </td> -->

                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>


                                <div class="total-table mb-2">
                                    <template v-for="(row, i) in totalTable">
                                        <v-row :key="i" class="px-3 px-lg-0 py-1 py-lg-0">
                                            <v-col cols="6" class="d-flex justify-start py-5 px-lg-6 medium-text" :class="{'text--text': !row.bold, 'strong-text--text font-weight-bold': row.bold}">{{row.text}}:</v-col>
                                            <v-col cols="6" class="d-flex justify-lg-start py-5 px-lg-6">
                                                <span class="black--text" :class="{'font-weight-bold': row.bold, 'primary--text': row.value < 0}">{{row.value}}</span>
                                            </v-col>
                                        </v-row>
                                        <v-divider v-if="i < totalTable.length-1" style="opacity: 0.7" :key="'d-' + i"></v-divider>
                                    </template>
                                </div>
                            </v-card-text>
                        </v-card>

                        <v-card flat class="bordered mb-4 mb-lg-6 py-lg-1 px-lg-2">
                            <v-card-title class="medium-title mb-1">
                                <!-- <v-icon color="strong-text" size="22" class="me-2">mdi-account-circle</v-icon> -->
                                <span>بيانات العميل</span>
                            </v-card-title>
                            <v-card-subtitle>بيانات العميل والتوصيل التي تم إدخالها أثناء الطلب</v-card-subtitle>
                            <v-card-text class="my-2">
                                <v-list class="pa-0 ma-0 transparent">
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-account-circle</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>اسم العميل</v-list-item-subtitle>
                                            <v-list-item-title>
                                                {{orderData.name}}
                                                <span v-if="!orderData.customer" class="details-text muted--text"> (بدون تسجيل دخول)</span>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-phone</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>رقم الهاتف</v-list-item-subtitle>
                                            <v-list-item-title class="ltr-dir text-right">{{orderData.phone_code}} {{orderData.phone}}</v-list-item-title>
                                            <v-list-item-title class="d-flex align-center">
                                                <v-btn as="a" x-small color="green darken-2" dark outlined target="_blank" :href="`https://api.whatsapp.com/send?phone=${orderData.phone_code}${orderData.phone}`">
                                                    <v-icon size="14" left class="me-1">mdi-whatsapp</v-icon>
                                                    <b>واتساب</b>
                                                </v-btn>
                                                    <v-btn as="a" x-small color="blue darken-2" dark outlined :href="`tel:${orderData.phone_code}${orderData.phone}`" class="ms-2">
                                                    <v-icon size="14" left class="me-0">mdi-phone</v-icon>
                                                    <b>اتصال</b>
                                                </v-btn>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-divider inset class="my-3"></v-divider>

                                    <v-list-item v-if="orderData.delivery_area" class="my-2">
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-truck-delivery-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>منطقة التوصيل</v-list-item-subtitle>
                                            <v-list-item-title style="white-space: pre-line;">
                                                <div>{{orderData.delivery_area.name}}</div>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item class="my-2">
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-map-marker-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>عنوان التوصيل</v-list-item-subtitle>
                                            <v-list-item-title style="white-space: pre-line;">
                                                <div><b>{{orderData.city}}</b></div>
                                                <div class="medium-text">{{orderData.address}}</div>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item class="my-2">
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-comment-text-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>تفاصيل أخرى</v-list-item-subtitle>
                                            <v-list-item-title style="white-space: pre-line;">
                                                <div v-if="orderData.notes">{{orderData.notes}}</div>
                                                <div class="muted--text details-text" v-else>لا يوجد</div>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                </v-list>
                            </v-card-text>
                        </v-card>

                        <v-card flat class="bordered mb-4 mb-lg-6 py-lg-1 px-lg-2">
                            <v-card-title class="medium-title mb-1">
                                <v-icon color="strong-text" size="22" class="me-2">mdi-credit-card-check-outline</v-icon>
                                <span>تفاصيل الدفع</span>
                            </v-card-title>
                            <!-- <v-card-subtitle>التفاصيل المرتبطة بعملية الدفع للطلب</v-card-subtitle> -->
                            <v-card-text class="mt-2">
                                <v-list class="pa-0 ma-0 transparent">
                                    <v-list-item v-if="orderData.payment_method === 'receipt'" class="my-2" @click="receiptDialog = true">
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-receipt</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>إيصال الدفع</v-list-item-title>
                                            <v-list-item-subtitle>
                                                اضغط لعرض الإيصال
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-icon color="grey">mdi-image-outline</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-list-item v-else-if="orderData.payment_method === 'cash'" class="my-2">
                                        <v-list-item-icon>
                                            <v-icon size="25" color="green darken-1">mdi-account-cash</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>طريقة الدفع</v-list-item-subtitle>
                                            <v-list-item-title>الدفع عند الاستلام</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                </v-list>
                            </v-card-text>
                        </v-card>
                    </div>
                    <div v-if="pcOnly">
                        <v-card class="transparent mb-3" flat width="275">
                            <v-card-title style="font-size: 1rem" class="py-2">إجراءات</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="px-0 py-1">
                                <v-list class="pa-0 transparent">
                                    <v-list-item v-for="action in actions" :key="action.name" @click="action.onclick" :disabled="action.disabled" v-ripple="{class: 'ripple--color'}">
                                        <v-list-item-icon class="me-4">
                                            <v-icon size="22" :color="action.color" :style="action.disabled ? 'opacity: 0.5' : ''">{{action.icon}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="medium-text mb-0" style="line-height: 1.6!important">{{action.title}}</v-list-item-title>
                                            <v-list-item-subtitle class="details-text" style="line-height: 1.5!important" :style="action.disabled ? 'opacity: 0.5' : ''">{{action.subtitle}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </div>
                </div>

                <v-dialog v-model="receiptDialog" max-width="600px" >
                    <v-card>
                        <v-card-title class="mb-2">
                            <v-icon color="strong-text" class="me-1">mdi-receipt</v-icon>
                            <span>إيصال الدفع</span>
                        </v-card-title>
                        <v-card-subtitle>صورة إيصال الدفع التي تم إرفاقها من قبل العميل أثناء الطلب</v-card-subtitle>
                        <v-card-text>
                            <img :src="orderData.payment_receipt_url" style="width: 100%; height: auto" />
                        </v-card-text>
                        <v-btn icon color="muted" absolute top left @click="receiptDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card>
                </v-dialog>

                <action-dialog v-model="statusDialog" scrollable max-width="420" vuex-action="updateOrderStatus" success-msg="تم تحديث الحالة بنجاح" title="تغيير حالة الطلب" subtitle="سيتم تنفيذ التغييرات لحظياً" button-text="تأكيد" :data="{id: id, data: {status: newStatus}}" @reset="newStatus = orderData.status" @sync="sync">
                    <div class="pt-1">
                        <v-select v-model="newStatus" label="حالة الطلب" :color="newStatus ? (getStatusChip(newStatus).color || 'primary') : 'primary'" :prepend-inner-icon="newStatus ? (getStatusChip(newStatus).icon || 'mdi-flag-outline') : 'mdi-flag-outline'" :items="orderStatusSelectItems" :menu-props="{ bottom: true, offsetY: true }">
                            <template v-slot:item="{item, on, attrs}">
                                <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-icon class="me-3">
                                        <v-icon :color="item.color || 'strong-text'">{{item.icon || 'mdi-flag-outline'}}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{item.text}}</v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>
                </action-dialog>

                <!-- <action-dialog v-model="editDialog" scrollable max-width="420" vuex-action="editOrder" success-msg="تم حفظ التغييرات بنجاح" title="تعديل الطلب" subtitle="سيتم تنفيذ التغييرات لحظياً" button-text="تعديل" :data="{id: id, data: editedItem}" @reset="resetEditForm" @sync="sync">
                    <div class="pt-1">
                        
                    </div>
                </action-dialog> -->

                <action-dialog v-model="deleteDialog" vuex-action="deleteOrder" :title="`حذف الطلب #${orderData.local_serial}`" :data="{id}" button-text="تأكيد الحذف" button-color="error" @sync="goToOrders">
                    هل أنت متأكد من حذف <b class="strong-text--text">الطلب رقم #{{orderData.local_serial}}</b> ؟
                    لن تتمكن من التراجع عن هذه الخطوة لاحقاً.
                </action-dialog>

                <order-invoice-dialog v-model="printDialog" :order="orderData" />
            </v-container>
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CrudTable from '@/components/default/crud-table'
import OrderInvoiceDialog from '@/components/custom/order-invoice-dialog'

export default {
    name: "Order",
    components: {
        CrudTable,
        OrderInvoiceDialog
    },
    data(){
        return {
            loading: false,   
            orderData: null,

            printDialog: false,

            receiptDialog: false,

            statusDialog: false,
            newStatus: '',

            editDialog: false,
            editedItem: {
                name: '',
                categories: [],
                track_stock: false,
                // hidden: false,
                featured: false,
            },

            deleteDialog: false,
            deleteItem: null,
            
            orderStatusItems: [
                {text: 'انتظار القبول', value: 'review', color: 'blue-grey', icon: 'mdi-file-document-outline'},
                {text: 'جاري التجهيز', value: 'in_progress', color: 'primary', icon: 'mdi-package-variant'},
                {text: 'جاري التوصيل', value: 'in_delivery', color: 'orange darken-2', icon: 'mdi-truck-fast-outline'},
                {text: 'تم التوصيل', value: 'delivered', color: 'indigo', icon: 'mdi-truck-check-outline'},
                {text: 'طلب مكتمل', value: 'completed', color: 'success', icon: 'mdi-check-circle-outline'},
                {text: 'طلب ملغي', value: 'canceled', color: 'red', icon: 'mdi-close-circle-outline'},
                {text: 'مرتجع', value: 'returned', color: 'deep-orange', icon: 'mdi-login'},
            ],
        };
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        orderStatusSelectItems(){
            const status = this.orderData.status;
            const index = this.orderStatusItems.findIndex(item=>item.value === status);
            return this.orderStatusItems.slice(index);
        },
        orderStatusChip(){
            const status = this.orderData.status;
            return this.getStatusChip(status);
        },
        totalTable(){
            const orderData = this.orderData;
            let rows = [
                {text: 'عدد العناصر', value: orderData.products_count},
                {text: 'عدد المنتجات', value: orderData.items_count},
                {text: 'المجموع', value: this.moneyFormat(orderData.subtotal, true)},
                {text: 'الخصم', value: this.moneyFormat(-1*orderData.total_discount, true)},
                {text: 'خصم الكوبون', value: this.moneyFormat(-1*orderData.coupon_discount, true)},
                {text: 'الإجمالي', value: this.moneyFormat(orderData.total, true), bold: true},
            ];
            if (orderData.delivery_price){
                rows.push(...[
                    {text: 'تكلفة التوصيل', value: this.moneyFormat(orderData.delivery_price, true)},
                    {text: 'الإجمالي + التوصيل', value: this.moneyFormat(orderData.total + orderData.delivery_price, true), bold: true},
                ]);
            }
                
            return rows;
        },
        actions(){
            return [
                {name: 'status', icon: 'mdi-flag-outline', color: 'primary', title: 'حالة الطلب', subtitle: 'تعديل حالة الطلب الحالية', onclick: this.openStatusDialog},
                // {name: 'edit', icon: 'mdi-square-edit-outline', color: 'muted', title: 'تعديل الطلب', subtitle: 'تعديل البيانات الرئيسية للطلب', onclick: this.openEditDialog},
                {name: 'print', hide: this.capRunning, icon: 'mdi-printer', color: 'strong-text', title: 'طباعة الطلب', subtitle: 'أمر طباعة فاتورة الطلب', onclick: this.openPrintDialog},
                {name: 'delete', icon: 'mdi-delete', color: 'error', title: 'حذف الطلب', subtitle: 'سيتم الحذف النهائي للطلب', onclick: this.openDeleteDialog},
            ]
        },
        
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        id(){
            this.loadOrderData();
        },
    },
    methods: {
        ...GlobalMethods,
        getStatusChip(status){
            const chip = this.orderStatusItems.find(item=>item.value === status);
            if (chip){
                return chip;
            }else{
                return {text: status, color: 'primary', icon: 'mdi-flag-outline'}
            }
        },
        loadOrderData(){
            if (!this.loading){
                this.loading = true;
                window.axios.get(`/orders/${this.id}`).then(response=>{
                    this.loading = false;
                    this.orderData = response.data.data;
                    if (this.orderData.variants && this.orderData.variants[0]){
                        this.selectedVariant = this.orderData.variants[0].id;
                    }
                }).catch(e=>{
                    this.loading = false;
                    this.goToOrders();
                    if (e && e.response && e.response.status === 404){
                        this.showMsg('الطلب غير موجود', 'error');
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل بيانات الطلب', 'error');
                    }
                })
            }
        },
        goToOrders(){
            this.$router.push({name: 'orders'});
        },
        openPrintDialog(){
            this.printDialog = true;
        },
        openStatusDialog(){
            this.newStatus = this.orderData.status;
            this.statusDialog = true;
        },
        openEditDialog(){
            // Object.assign(this.editedItem, item);
            this.editDialog = true;
        },
        resetEditForm(){
            this.editedItem = {
                id: '',
                name: '',
                categories: [],
                track_stock: false,
                hidden: false,
                featured: false,
            };
        },
        resetNewVariantForm(){
            this.newVariant = {
                name: '',
                stock: '',
                price: '',
            };
        },
        openDeleteDialog(item){
            this.deleteDialog = true;
            this.deleteItem = item;
        },
        sync(data){
            Object.assign(this.orderData, data);
        },
    },
    mounted(){
        this.loadOrderData();
    }
};
</script>

<style lang="scss" scoped>
.variant-photo{
    .photo-actions{
        opacity: 0;
        transition: 0.2s ease all;
    }
    &:hover{
        .photo-actions{
            opacity: 1;
        }
    }
}
.add-image{
    border-radius: 4px;
    border: 2px dashed rgba(0,0,0, .1)!important;
    cursor: pointer;
    transition: 80ms ease-out all;

    &:hover{
        border-color: rgba(0,0,0, .3)!important;
    }
    &:active{
        transform: scale(0.97);
    }
}
</style>
<style lang="scss">
.description-textarea{
    textarea{
        font-size: 13px;
        line-height: 1.55rem!important;
    }
    &:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot{
        fieldset{
            color: rgba(0, 0, 0, 0.04)!important;
        }

        &:hover{
            fieldset{
                color: rgba(0, 0, 0, 0.2)!important;
            }
        }
    }
}
</style>
